// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","expandableSection":"G8b4c3a","expandedContent":"G0af61c"};